/*
 * form Sagas
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 12-Jan-2023
 */

import { put, fork, take, call, all, takeLatest } from 'redux-saga/effects';
import { delay } from 'Store/sagas/index';
import * as api from 'Api/home/home';
import * as actions from '../actions/form';

function* getCountries() {
  const { error, response } = yield call(api.getCountries);

  if (!error) {
    yield put(actions.getCountries.success(response.data));
  } else {
    yield put(actions.getCountries.failure(error));
  }
}
// @generator saga

// @generator saga:watch

function* watchGetCountries() {
  yield takeLatest(actions.actionTypes.GET_COUNTRIES_REQUEST, getCountries);
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* rootSaga() {
  yield all([
    watchGetCountries(),
    // @generator saga:fork
  ]);
}
